import React, { Fragment } from 'react';
import { Accordion, Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import QuestionItem from './QuestionHelperComponents/QuestionItem';
import { ChevronRight, TooltipInfoIcon /* IcoWarning */ } from '@icons';
const SubCategory = ({
  subCategory,
  questions,
  handleAssessmentChange,
  questionVisibility,
  handleValue,
  handleChecked,
  userRole,
  translations,
  assessment,
  areInputsDisabled,
  isMonitoring,
}) => (
  <div className='mx-3' key={subCategory.code}>
    <div style={{ width: '100%' }}>
      <Accordion style={{ marginBottom: '1.5rem' }}>
        <Accordion.Collapse eventKey={String(subCategory.code)}>
          <Fragment key={subCategory.code}>
            {questions
              .filter(
                (question) =>
                  question.subcategory === subCategory.code &&
                  questionVisibility[question.id] === true,
              )
              .sort((a, b) => a.order - b.order)
              .map((question) => (
                <QuestionItem
                  key={question.id}
                  question={question}
                  handleAssessmentChange={handleAssessmentChange}
                  questionVisibility={questionVisibility}
                  isVisible={questionVisibility[question.id] === true}
                  handleValue={handleValue}
                  handleChecked={handleChecked}
                  userRole={userRole}
                  translations={translations}
                  assessment={assessment} // Pass assessment prop
                  areInputsDisabled={areInputsDisabled} // Pass areInputsDisabled prop
                  isMonitoring={isMonitoring}
                />
              ))}
          </Fragment>
        </Accordion.Collapse>
        <Accordion.Toggle
          as='h5'
          className='accordion-title'
          eventKey={String(subCategory.code)}
          style={{ margin: '0' }}>
          <div className='row'>
            <div className='col-10 px-3'>
              <div
                className='d-flex title-simple-box margin-title-box align-items-center'
                style={{ height: '100%' }}>
                {subCategory.text}
                {subCategory.description ? (
                  <OverlayTrigger
                    placement='right'
                    delay={{ show: 200, hide: 400 }}
                    overlay={renderTooltip}
                    popperConfig={{ testObj: subCategory.description }}>
                    <TooltipInfoIcon className='tooltip-ico' style={{ width: '1rem' }} />
                  </OverlayTrigger>
                ) : null}
              </div>
            </div>
            <div className='col-2 align-self-center pl-2 py-2 text-center'>
              <ChevronRight className='accordion-arrow' />
            </div>
          </div>
        </Accordion.Toggle>
      </Accordion>
    </div>
  </div>
);

const renderTooltip = (props, classWidth) => {
  let message = '';
  //console.log('classWidth', classWidth);
  //console.log('props', props);

  if (props.popper.state) {
    message = props.popper.state.options.testObj;
  }

  return (
    <Tooltip id='button-tooltip' {...props} {...(classWidth ? { className: classWidth } : null)}>
      {message}
    </Tooltip>
  );
};
const Category = ({
  category,
  subCategories,
  questions,
  handleAssessmentChange,
  questionVisibility,
  handleValue,
  handleChecked,
  userRole,
  translations,
  assessment,
  areInputsDisabled,
  isMonitoring,
}) => {
  return (
    <div className='simple-box' style={{ marginTop: '2.3rem' }} key={category.code}>
      <div className='row'>
        <div className='col-lg-12'>
          <div className='form-login'>
            <Accordion defaultActiveKey={'E'}>
              <Accordion.Collapse style={{ marginTop: '2rem' }} eventKey={String(category.code)}>
                <Card.Body>
                  {subCategories
                    .filter((subCategory) => subCategory.category === category.code)
                    .sort((a, b) => a.order - b.order)
                    .map((subCategory, index) => (
                      <SubCategory
                        key={subCategory.code}
                        subCategory={subCategory}
                        questions={questions}
                        handleAssessmentChange={handleAssessmentChange}
                        questionVisibility={questionVisibility}
                        handleValue={handleValue}
                        handleChecked={handleChecked}
                        userRole={userRole}
                        index={index}
                        translations={translations}
                        assessment={assessment} // Pass assessment prop
                        areInputsDisabled={areInputsDisabled} // Pass areInputsDisabled prop
                        isMonitoring={isMonitoring}
                      />
                    ))}
                </Card.Body>
              </Accordion.Collapse>
              <Accordion.Toggle
                as='h3'
                className='accordion-title'
                eventKey={String(category.code)}
                style={{ margin: '0' }}>
                <div className='row'>
                  <div className='col-10 px-3'>
                    <div className='d-flex align-items-center' style={{ height: '100%' }}>
                      {category.text}
                      {category.description ? (
                        <OverlayTrigger
                          placement='right'
                          delay={{ show: 200, hide: 400 }}
                          overlay={(props) => renderTooltip(props, 'tooltip-maxWith')}
                          popperConfig={{ testObj: category.description }}>
                          <TooltipInfoIcon className='tooltip-ico' style={{ width: '1rem' }} />
                        </OverlayTrigger>
                      ) : null}
                    </div>
                  </div>
                  <div className='col-2 align-self-center pl-2 py-2 text-center'>
                    <ChevronRight className='accordion-arrow' />
                  </div>
                </div>
              </Accordion.Toggle>
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Category;
